export const spaceName = 'odDish';

export interface DishSettings {
  editingId: number;

  originalData: {
    originalBasicInfo: any;
    originalStockInfo: any;
  };

  currentData: {
    currentBasicInfo: any;
    currentStockInfo: any;
  };

  allMenus: any[];

  relationData: any;

  showRecurringStockModal: {
    show: boolean;
    key?: 'edit';
  };
  editingStock: number;
  activeStockTab: 'daily' | 'recurring';
}

export default {
  showRecurringStockModal: {
    show: false,
  },
  activeStockTab: 'daily',
} as DishSettings;
